import React, { PureComponent } from 'react'
import { FORM_ERROR } from 'final-form'
import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import validate from 'validate.js'
import { Button, InputField } from '@mc/design-system'
import { Trans, withTranslation } from '@mc/i18n'
import { RESET_PASSWORD_TITLE } from '../constants'
import { resetPassword } from '../services'

const constraints = {
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Invalid email' },
  },
}

class ResetPasswordForm extends PureComponent {
  static propTypes = {
    onLoginClick: PropTypes.func.isRequired,
    t: PropTypes.func,
  }

  state = { submitSucceeded: false }

  handleSubmit = async (values) => {
    try {
      await resetPassword(values)
      this.setState({ submitSucceeded: true })
      return {}
    } catch (err) {
      return { [FORM_ERROR]: 'An error occurred, please try again.' }
    }
  }

  render() {
    const { onLoginClick, t } = this.props
    const { submitSucceeded } = this.state

    return (
      <div>
        <h4 className='mc-text-h4 mc-text--center mc-mb-6'>
          {RESET_PASSWORD_TITLE}
        </h4>

        {!submitSucceeded && (
          <Form
            onSubmit={this.handleSubmit}
            validate={(values) =>
              validate(values, constraints, { fullMessages: false })
            }
            render={({ handleSubmit, submitting, submitError }) => (
              <form onSubmit={handleSubmit}>
                {!submitting && submitError && (
                  <p
                    aria-live='assertive'
                    className='mc-text--error mc-text--center mc-mb-4'
                  >
                    {submitError}
                  </p>
                )}

                <Field
                  component={InputField}
                  className='mc-mb-4'
                  type='email'
                  name='email'
                  label='Email'
                  data-ba='email-input'
                  required
                  autocomplete='email'
                />

                <Button
                  data-ba='submit-btn'
                  type='submit'
                  loading={submitting}
                  fullWidth
                >
                  {t('resetPasswordForm.sendEmail')}
                </Button>

                <p className='mc-text--center mc-mt-4'>
                  <Trans
                    i18nKey='resetPasswordForm.rememberPassword'
                    ns='@mc/authentication'
                  >
                    <a className='mc-text--link' onClick={onLoginClick} />
                  </Trans>
                </p>
              </form>
            )}
          />
        )}

        {submitSucceeded && (
          <>
            <p className='mc-text--center mc-mb-3'>
              {t('resetPasswordForm.existingUser')}
            </p>
            <p className='mc-text--center mc-mb-3'>
              {t('resetPasswordForm.signUpThirdParties')}
            </p>
            <p className='mc-text--center'>
              <Trans
                i18nKey='resetPasswordForm.rememberPassword'
                ns='@mc/authentication'
              >
                <a className='mc-text--link' onClick={onLoginClick} />
              </Trans>
            </p>
          </>
        )}
      </div>
    )
  }
}

export default withTranslation('@mc/authentication')(ResetPasswordForm)
